import { render, staticRenderFns } from "./set-password-dialog.component.vue?vue&type=template&id=cbab2738"
import script from "./set-password-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./set-password-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports